import {HttpServer} from './http.server';
import {apis} from './apis';
import {getJti} from './appUtils';
export const CheckToken = {
  start: function (time) {
    if (getJti()) {
      if (time === 0) {
        setTimeout(function () {
          HttpServer.get(apis.api.system.checkToken + getJti()).then(res => {
            console.log(res);
          }).catch(err => {
            console.log(err);
          });
        }, 100);
      } else {
        setInterval(function () {
          HttpServer.get(apis.api.system.checkToken + getJti()).then(res => {
            console.log(res);
          }).catch(err => {
            console.log(err);
          });
        }, time);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/checkToken.js